import React, { PureComponent } from 'react';

import '../scss/RelatedResearch.scss'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class RelatedResearch extends PureComponent {
    constructor (props) {
        super(props);
    }

    stripSummaryContent = (s) => {
        let div = document.createElement("div");
        div.innerHTML = s.replace('|', '');
        return div.textContent || div.innerText || "";
    }

    render () {
        return (
            this.props.relatedDocs.map( (doc, idx) => {
                let docIndex = (idx + 1);
                let docPublishedDate = doc.publishDate ? `Published: ${doc.publishDate}` : '';
                let summary = this.stripSummaryContent(doc.summary);
                let previewSummary = summary.substring(0, 100);
                let remainingSummary = summary.substring(100, summary.length);
                let suffix = (remainingSummary.length > 0 ? "..." : "");

                return (
                    <div key={"related-research-doc-" + docIndex} className="related-research-doc">
                        <div className="doc-title">
                            <a href={ doc.downloadUrl } target="_blank" onClick={ this.props.handleRelatedResearchClick }> { doc.title } </a>
                        </div>
                        <div className="doc-publish-date">
                            <p>{ docPublishedDate }</p>
                        </div>
                        <div className="doc-summary" id={"doc-summary-"+ docIndex}>
                            <span>{ previewSummary + suffix }</span><span className="hidden">{ remainingSummary }</span>
                        </div>
                        <div className={"arrow-icon" + (remainingSummary.length === 0 ? " hidden " : "")} id={"doc-arrow-icon-" + docIndex}
                             onClick={ () => this.props.handleSummaryArrowClick("doc-arrow-icon-"+ docIndex, "doc-summary-"+ docIndex) }>

                            <FontAwesomeIcon icon="angle-double-down" size="sm" />
                            <FontAwesomeIcon icon="angle-double-up" size="sm" className="hidden" />
                        </div>
                        <hr />
                    </div>
                );
            })
        );
    }
}

export default RelatedResearch;
